var MediaThumbnail = require("app/ui/thumbnails/MediaThumbnail"),
    get            = require("object-path").get,
    icons          = require("app/theme/icons"),
    kind           = require("enyo/kind");

module.exports = kind(/** @lends  app.ui.thumbnails.PodcastEpisodeThumbnail.prototype */ {

    /**
     * @private
     */
    name: "app.ui.thumbnails.PodcastEpisodeThumbnail",

    /**
     * @private
     */
    kind: MediaThumbnail,

    /**
     * @private
     */
    classes: "app-ui-thumbnails-podcast-episode-thumbnail",

    /**
     * Update the component in response to state changes.
     *
     * @public
     */
    update: kind.inherit(function(sup) {
        return function() {
            var i18nService   = this.app.$.i18nService,
                data          = this.data || {},
                $imageWrapper = this.$.imageWrapper;

            $imageWrapper.set("href", get(data, "links.player", null));
            $imageWrapper.setAttribute("title", i18nService.getString("app.ui.thumbnails.PodcastEpisodeThumbnail.playerLink.tooltip"));

            this.$.playIcon.set("icon", icons["app.ui.thumbnails.PodcastEpisodeThumbnail.playIcon"]);

            this.$.infoLink.setAttribute("title", i18nService.getString("app.ui.thumbnails.PodcastEpisodeThumbnail.infoLink.tooltip"));

            sup.apply(this, arguments);
        };
    })

});
